// Tickets en los portales de los fabricantes (Jimi y Queclink).

import { api } from "./http";

// --- Ticket en Jimi (sistema de soporte del fabricante) ---
export type JimiNota = { fecha: string; autor: string | null; texto: string; tags: string[] };
export type JimiCategoria = {
  dict_data_id: number;
  code: string;
  nombre: string;
  children: JimiCategoria[];
};
/** Modelo del catálogo de Jimi («objeto de la queja») con su línea de producto. */
export type JimiObjetoQueja = {
  code: string;
  nombre: string;
  linea_code: string;
  linea_nombre: string;
};
/** Equipos del caso agrupados por modelo interno de Jimi (el portal exige uno solo). */
export type JimiModeloGrupo = {
  modelo: string;
  nombre: string;
  /** Lo que se pinta: el nombre, más «(modelo interno X)» si dos grupos se llaman igual. */
  etiqueta: string;
  imeis: string[];
};
export type JimiPrefill = {
  titulo: string;
  descripcion: string;
  imeis: string[];
  categorias: JimiCategoria[];
  bitacora: JimiNota[];
  sugerencia_etiqueta_dict_data_id: number | null;
  objetos_queja: JimiObjetoQueja[];
  sugerencia_objeto_queja: string | null;
  /** Revisión de los equipos en Jimi: solo aviso, el alta vuelve a revisar. */
  modelos: JimiModeloGrupo[];
  modelos_verificados: boolean;
  imeis_no_validos: string[];
  customer_email: string;
  evidencia_url: string | null;
  puede_generar_evidencia: boolean;
  ia_habilitada: boolean;
  ya_tiene: boolean;
};
export type JimiAbrirOut = {
  work_order_no: string;
  work_order_id: number | null;
  origen: "boton" | "manual";
  ya_existia: boolean;
};

export function jimiPrefill(casoId: number) {
  return api.get<JimiPrefill>(`/api/casos/${casoId}/jimi/prefill`);
}
export function jimiAbrirCrear(
  casoId: number,
  body: {
    titulo: string;
    descripcion: string;
    categoria_dict_data_id: number;
    objeto_queja_code: string;
    evidencia_url: string | null;
  },
) {
  return api.post<JimiAbrirOut>(`/api/casos/${casoId}/jimi/abrir`, { modo: "crear", ...body });
}
export type JimiRevisarOut = {
  work_order_no: string;
  /** Cuántas respuestas del FAE se agregaron a la bitácora en esta pasada. */
  nuevas: number;
  estado_jimi: number | null;
  revisado_at: string;
};

export function jimiRevisar(casoId: number) {
  return api.post<JimiRevisarOut>(`/api/casos/${casoId}/jimi/revisar`);
}

export type QueclinkRevisarOut = {
  ticket_id: number;
  /** Cuántas respuestas de Queclink entraron a la bitácora en esta pasada. */
  nuevas: number;
  estado: string | null;
  revisado_at: string;
};

export function queclinkRevisar(casoId: number) {
  return api.post<QueclinkRevisarOut>(`/api/casos/${casoId}/queclink/revisar`);
}

export function queclinkVincular(casoId: number) {
  return api.post<{ ticket_id: number | null }>(`/api/casos/${casoId}/queclink/vincular`);
}

export function jimiCapturarManual(casoId: number, numero: string) {
  return api.post<JimiAbrirOut>(`/api/casos/${casoId}/jimi/abrir`, { modo: "manual", numero });
}
export function jimiGenerarEvidencia(casoId: number) {
  return api.post<{ evidencia_url: string }>(`/api/casos/${casoId}/jimi/evidencia`);
}
export function jimiQuitar(casoId: number) {
  return api.del<void>(`/api/casos/${casoId}/jimi`);
}
